import { initializeHeader } from "./header";
import { getHtml } from "../apis/templateHtml";
import { navigate } from "../router/router";
import { startLoadingDisplay, endLoadingDisplay } from "../modules/uiManager/UiLoadingDisplay";
import { getUserInformationCached } from "../modules/userManager/UserManager";
import { showPopupAlert, showPopupConfirm } from "../modules/uiManager/UiPopup";
import { populateSelect, isCodeMasterLoaded, fetchCodeMaster, setCodeMaster } from "../modules/codeMasterManager/CodeMasterManager";
import { openCandidateSearch, openStoreSearch, openEmployeeSearch, openVendorSearch } from "../modules/searchModal/SearchModalConfigs";
import { uploadGcsFile, deleteGcsFile } from "../apis/firebaseStorage";
import { fetchFieldSurveyRequestDetail, retryFieldSurveyRequest, getApiErrorMessage } from "../apis/fieldSurveyRequestApi";
import { fetchOperationPermissions } from "../apis/graphqlClient";
import { getOperationPermission, setOperationPermissions, isOperationPermissionsLoaded } from "../modules/permissionManager/PermissionManager";
import { loadMockZoData, loadMockDoData, getAllZone, getAllDo } from "../data/zodoData";
const OPTIONAL_DOCUMENTS = [
    '公図', '住宅地図', '敷地実測図', '簡易CAD', '簡易概算',
    '土地謄本', '建物謄本', '配置プラン', '店内レイアウト/ビル図面'
];
const STORE_SEARCH_ENABLED_TYPES = ['020', '030', '031', '032'];
const PARKING_EXPANSION_TYPES = ['030', '031', '032'];
let documentRows = [];
function updateStoreSearchState(_handlingType) {
    const btn = document.getElementById('btnStoreSearch');
    if (btn) {
        btn.disabled = true;
        btn.style.opacity = '0.5';
    }
    const input = document.getElementById('txtStoreNo');
    if (input) {
        input.disabled = true;
        input.classList.add('form-input-disabled');
    }
}
function updateRequiredMarks(handlingType) {
    const isParkingType = PARKING_EXPANSION_TYPES.includes(handlingType);
    const isStoreEnabled = STORE_SEARCH_ENABLED_TYPES.includes(handlingType);
    const candidateLabel = document.getElementById('txtCandidateId')?.parentElement?.previousElementSibling;
    const storeLabel = document.getElementById('txtStoreNo')?.parentElement?.previousElementSibling;
    if (candidateLabel) {
        candidateLabel.classList.toggle('required', !isParkingType && !!handlingType);
    }
    if (storeLabel) {
        storeLabel.classList.toggle('required', isStoreEnabled);
    }
}
function onHandlingTypeChange(handlingType) {
    updateStoreSearchState(handlingType);
    updateRequiredMarks(handlingType);
    const currentState = new Map();
    const customRows = [];
    documentRows.forEach(row => {
        if (row.isCustom) {
            customRows.push(row);
        }
        else {
            currentState.set(row.documentName, row);
        }
    });
    documentRows = [];
    OPTIONAL_DOCUMENTS.forEach(name => {
        documentRows.push(currentState.get(name) || { documentName: name, fileName: '', uploader: '', uploadDate: '', isCustom: false, gcsPath: '' });
    });
    customRows.forEach(row => documentRows.push(row));
    renderDocumentTable();
}
function setupHandlingTypeControl() {
    const sel = document.getElementById('selHandlingType');
    if (!sel)
        return;
    sel.addEventListener('change', () => onHandlingTypeChange(sel.value));
    updateStoreSearchState(sel.value);
    updateRequiredMarks(sel.value);
}
function getTodayString() {
    const now = new Date();
    const y = now.getFullYear();
    const m = String(now.getMonth() + 1).padStart(2, '0');
    const d = String(now.getDate()).padStart(2, '0');
    const hh = String(now.getHours()).padStart(2, '0');
    const mm = String(now.getMinutes()).padStart(2, '0');
    const ss = String(now.getSeconds()).padStart(2, '0');
    return `${y}/${m}/${d} ${hh}:${mm}:${ss}`;
}
function populateZoSelect() {
    const sel = document.getElementById('selZO');
    if (!sel)
        return;
    const zone = getAllZone();
    let html = '<option value="">-- 選択 --</option>';
    for (const key in zone.zone_data) {
        const z = zone.zone_data[key];
        html += `<option value="${z.zone_code}">${z.zone_name}</option>`;
    }
    sel.innerHTML = html;
}
function populateDoSelect() {
    const sel = document.getElementById('selDO');
    if (!sel)
        return;
    const doInfo = getAllDo();
    let html = '<option value="">-- 選択 --</option>';
    for (const key in doInfo.do_data) {
        const d = doInfo.do_data[key];
        html += `<option value="${d.do_code}">${d.do_name}</option>`;
    }
    sel.innerHTML = html;
}
function initializeFormSelects() {
    populateSelect('selHandlingType', 'handling_type', '選択してください');
    populateSelect('selPrefecture', 'prefecture', '選択してください');
    populateSelect('selContractType', 'contract_type', '選択してください');
    populateSelect('selOwnership', 'ownership_type', '選択してください');
    populateSelect('selBuildingType', 'building_type', '選択してください');
    populateSelect('selLicense', 'license_plan', '選択してください');
    populateSelect('selSubmissionMethod', 'submission_method', '選択してください');
    populateZoSelect();
    populateDoSelect();
}
function generateAutoFileName(file, row) {
    if (row.isCustom)
        return file.name;
    const now = new Date();
    const yyyymmdd = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}`;
    const handlingType = document.getElementById('selHandlingType')?.value || '';
    const isParkingType = PARKING_EXPANSION_TYPES.includes(handlingType);
    const identifier = isParkingType
        ? document.getElementById('txtStoreNo')?.value || ''
        : document.getElementById('txtCandidateId')?.value || '';
    const seqNo = 1;
    const sanitizedDocName = row.documentName.replace(/\//g, '_');
    const ext = file.name.includes('.') ? file.name.split('.').pop() || '' : '';
    return `${yyyymmdd}_${seqNo}_${identifier}_${sanitizedDocName}.${ext}`;
}
function getInternalId() {
    return document.getElementById('lblInternalId')?.value || '';
}
function escapeHtml(str) {
    if (!str)
        return '';
    const div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
}
function toDateInputValue(dateStr) {
    if (!dateStr)
        return '';
    return dateStr.replace(/\//g, '-');
}
function populateForm(data) {
    const setVal = (id, val) => {
        const el = document.getElementById(id);
        if (el)
            el.value = String(val ?? '');
    };
    setVal('lblInternalId', data.internalId);
    setVal('lblRequestCount', (Number(data.requestCount) || 0) + 1);
    setVal('lblRequestDate', getTodayString());
    setVal('selHandlingType', data.handlingTypeCode);
    setVal('txtCandidateId', data.candidateId);
    setVal('txtStoreNo', data.storeNo);
    setVal('txtStoreName', data.storeName);
    setVal('txtStoreNameKana', data.storeNameKana);
    setVal('selPrefecture', data.prefectureCode);
    setVal('selZO', data.zo);
    setVal('selDO', data.do);
    setVal('txtAddress', data.address);
    setVal('selContractType', data.contractTypeCode);
    setVal('selBuildingType', data.buildingTypeCode);
    setVal('selLicense', data.licenseCode);
    setVal('dtOpenDate', toDateInputValue(data.openDate));
    setVal('dtSurveyDesiredDate', toDateInputValue(data.surveyDesiredDate));
    setVal('dtReportDueDate', toDateInputValue(data.reportDueDate));
    setVal('selSubmissionMethod', data.submissionMethodCode);
    setVal('selOwnership', data.ownershipCode);
    setVal('txtRemarks', data.remarks);
    const chk = document.getElementById('chkConfirmation');
    if (chk)
        chk.checked = !!data.confirmation;
    setVal('txtApproverCode', data.approverCode);
    setVal('txtApprover', data.approverName);
    setVal('txtDesignOfficeCode', data.designOfficeCode);
    setVal('txtDesignOffice', data.designOfficeName);
    setVal('txtDmCode', data.dmCode);
    setVal('txtDm', data.dmName);
}
async function initializeRequester() {
    try {
        const userInfo = await getUserInformationCached(false);
        const employeeName = userInfo?.[0]?.employee_name || '';
        const employeeNo = userInfo?.[0]?.employee_no || '';
        const txtRequester = document.getElementById('txtRequester');
        if (txtRequester)
            txtRequester.value = employeeName;
        const txtRequesterCode = document.getElementById('txtRequesterCode');
        if (txtRequesterCode)
            txtRequesterCode.value = employeeNo;
    }
    catch (error) {
        console.error('依頼者情報の取得に失敗:', error);
    }
}
function initializeDocumentTable() {
    const sel = document.getElementById('selHandlingType');
    const handlingType = sel?.value || '';
    documentRows = [];
    OPTIONAL_DOCUMENTS.forEach(name => {
        documentRows.push({ documentName: name, fileName: '', uploader: '', uploadDate: '', isCustom: false, gcsPath: '' });
    });
    renderDocumentTable();
}
function renderDocumentTable() {
    const tbody = document.getElementById('documentTableBody');
    if (!tbody)
        return;
    let html = '';
    documentRows.forEach((row, index) => {
        html += `
      <tr>
        <td>
          ${row.isCustom
            ? `<input type="text" class="doc-name-input" data-index="${index}" value="${escapeHtml(row.documentName)}" placeholder="書類名を入力" />`
            : `<span>${escapeHtml(row.documentName)}</span>`}
        </td>
        <td>${escapeHtml(row.fileName)}</td>
        <td>${escapeHtml(row.uploader)}</td>
        <td>${escapeHtml(row.uploadDate)}</td>
        <td>
          <button type="button" class="pill-button-outline doc-upload-btn" data-index="${index}" style="padding: 4px 12px; font-size: 12px;">
            <span class="material-icons" style="font-size: 14px;">upload_file</span>選択
          </button>
          <input type="file" class="doc-file-input" data-index="${index}" style="display: none;" />
        </td>
        <td>
          ${row.fileName
            ? `<button type="button" class="doc-delete-btn" data-index="${index}" style="background:none;border:none;cursor:pointer;color:#d32f2f;">
                <span class="material-icons">delete</span>
              </button>`
            : (row.isCustom
                ? `<button type="button" class="doc-remove-row-btn" data-index="${index}" style="background:none;border:none;cursor:pointer;color:#999;">
                  <span class="material-icons">close</span>
                </button>`
                : '')}
        </td>
      </tr>
    `;
    });
    tbody.innerHTML = html;
    setupDocumentEventListeners();
}
function setupDocumentEventListeners() {
    document.querySelectorAll('.doc-upload-btn').forEach(btn => {
        btn.addEventListener('click', () => {
            const index = parseInt(btn.dataset.index || '0', 10);
            const fileInput = document.querySelector(`.doc-file-input[data-index="${index}"]`);
            if (fileInput)
                fileInput.click();
        });
    });
    document.querySelectorAll('.doc-file-input').forEach(input => {
        input.addEventListener('change', async (e) => {
            const target = e.target;
            const index = parseInt(target.dataset.index || '0', 10);
            const file = target.files?.[0];
            if (!file || !documentRows[index])
                return;
            const autoFileName = generateAutoFileName(file, documentRows[index]);
            const internalId = getInternalId();
            const gcsPath = `${internalId}/${autoFileName}`;
            const uploadBtn = document.querySelector(`.doc-upload-btn[data-index="${index}"]`);
            if (uploadBtn) {
                uploadBtn.disabled = true;
                uploadBtn.innerHTML = '<span class="material-icons" style="font-size: 14px;">hourglass_top</span>0%';
            }
            try {
                await uploadGcsFile(gcsPath, file, (percent) => {
                    if (uploadBtn) {
                        uploadBtn.innerHTML = `<span class="material-icons" style="font-size: 14px;">hourglass_top</span>${percent}%`;
                    }
                });
                documentRows[index].fileName = autoFileName;
                documentRows[index].uploader = document.getElementById('txtRequester')?.value || '';
                documentRows[index].uploadDate = getTodayString();
                documentRows[index].gcsPath = gcsPath;
                renderDocumentTable();
            }
            catch (error) {
                console.error('ファイルアップロードに失敗:', error);
                showPopupAlert({ text: 'ファイルのアップロードに失敗しました。', showBackdrop: true });
                if (uploadBtn) {
                    uploadBtn.disabled = false;
                    uploadBtn.innerHTML = '<span class="material-icons" style="font-size: 14px;">upload_file</span>選択';
                }
            }
        });
    });
    document.querySelectorAll('.doc-delete-btn').forEach(btn => {
        btn.addEventListener('click', async () => {
            const index = parseInt(btn.dataset.index || '0', 10);
            if (!documentRows[index])
                return;
            const gcsPath = documentRows[index].gcsPath;
            if (gcsPath) {
                try {
                    await deleteGcsFile(gcsPath);
                }
                catch (error) {
                    console.error('GCSファイル削除に失敗:', error);
                }
            }
            documentRows[index].fileName = '';
            documentRows[index].uploader = '';
            documentRows[index].uploadDate = '';
            documentRows[index].gcsPath = '';
            renderDocumentTable();
        });
    });
    document.querySelectorAll('.doc-remove-row-btn').forEach(btn => {
        btn.addEventListener('click', () => {
            const index = parseInt(btn.dataset.index || '0', 10);
            documentRows.splice(index, 1);
            renderDocumentTable();
        });
    });
    document.querySelectorAll('.doc-name-input').forEach(input => {
        input.addEventListener('change', (e) => {
            const target = e.target;
            const index = parseInt(target.dataset.index || '0', 10);
            if (documentRows[index]) {
                documentRows[index].documentName = target.value;
            }
        });
    });
}
function validateForm() {
    const handlingType = document.getElementById('selHandlingType')?.value || '';
    const isStoreEnabled = STORE_SEARCH_ENABLED_TYPES.includes(handlingType);
    const isParkingType = PARKING_EXPANSION_TYPES.includes(handlingType);
    const requiredFields = [
        { id: 'selHandlingType', name: '取扱区分' },
        ...(!isParkingType ? [{ id: 'txtCandidateId', name: '候補地番号' }] : []),
        ...(isStoreEnabled ? [{ id: 'txtStoreNo', name: '店番' }] : []),
        { id: 'txtStoreName', name: '店名' },
        { id: 'selPrefecture', name: '都道府県' },
        { id: 'selZO', name: 'ZO' },
        { id: 'selDO', name: 'DO' },
        { id: 'selContractType', name: '契約タイプ' },
        { id: 'selOwnership', name: '契約形態(所有区分)' },
        { id: 'selBuildingType', name: '建物種類' },
        { id: 'dtOpenDate', name: '開店予定日' },
        { id: 'dtSurveyDesiredDate', name: '現地調査希望日' },
        { id: 'dtReportDueDate', name: '現地調査報告書提出予定日' },
        { id: 'selSubmissionMethod', name: '提出方法' },
        { id: 'txtRetryReason', name: '再依頼理由' },
        { id: 'txtRequester', name: '依頼者' },
        { id: 'txtApprover', name: '部門承認者' },
        { id: 'txtDm', name: 'DM' },
    ];
    const emptyFields = [];
    let hasError = false;
    requiredFields.forEach(({ id, name }) => {
        const el = document.getElementById(id);
        if (el) {
            const value = el.value.trim();
            if (!value) {
                el.style.borderColor = '#d32f2f';
                emptyFields.push(name);
                hasError = true;
            }
            else {
                el.style.borderColor = '';
            }
        }
    });
    const chk = document.getElementById('chkConfirmation');
    if (chk && !chk.checked) {
        emptyFields.push('確認事項');
        hasError = true;
    }
    if (hasError) {
        showPopupAlert({ text: `必須項目を入力してください。（${emptyFields.join('、')}）`, showBackdrop: true });
        return false;
    }
    const formatRules = [
        { id: 'txtCandidateId', name: '候補地番号', pattern: /^[a-zA-Z0-9]*$/, format: '半角英数字' },
        { id: 'txtStoreNo', name: '店番', pattern: /^[0-9]*$/, format: '半角数字' },
        { id: 'txtStoreName', name: '店名', pattern: /^[^\x20-\x7E]*$/, format: '全角' },
        { id: 'txtStoreNameKana', name: '店名カナ', pattern: /^[^\x20-\x7E]*$/, format: '全角' },
    ];
    const formatErrors = [];
    formatRules.forEach(({ id, name, pattern, format }) => {
        const el = document.getElementById(id);
        if (el && el.value && !el.disabled && !pattern.test(el.value)) {
            el.style.borderColor = '#d32f2f';
            formatErrors.push(`${name}(${format})`);
        }
    });
    if (formatErrors.length > 0) {
        showPopupAlert({ text: `入力形式が不適切です。（${formatErrors.join('、')}）`, showBackdrop: true });
        return false;
    }
    return true;
}
function collectFormData() {
    const getVal = (id) => {
        const el = document.getElementById(id);
        return el ? el.value.trim() : '';
    };
    const chk = document.getElementById('chkConfirmation');
    return {
        originalInternalId: getVal('lblInternalId'),
        handlingType: getVal('selHandlingType'),
        candidateId: getVal('txtCandidateId'),
        storeNo: getVal('txtStoreNo'),
        storeName: getVal('txtStoreName'),
        storeNameKana: getVal('txtStoreNameKana'),
        prefecture: getVal('selPrefecture'),
        zo: getVal('selZO'),
        do: getVal('selDO'),
        address: getVal('txtAddress'),
        contractType: getVal('selContractType'),
        ownership: getVal('selOwnership'),
        buildingType: getVal('selBuildingType'),
        license: getVal('selLicense'),
        openDate: getVal('dtOpenDate'),
        surveyDesiredDate: getVal('dtSurveyDesiredDate'),
        reportDueDate: getVal('dtReportDueDate'),
        submissionMethod: getVal('selSubmissionMethod'),
        confirmation: chk ? chk.checked : false,
        retryReason: getVal('txtRetryReason'),
        remarks: getVal('txtRemarks'),
        approverCode: getVal('txtApproverCode'),
        dmCode: getVal('txtDmCode'),
        designOfficeCode: getVal('txtDesignOfficeCode'),
        documents: documentRows
            .filter(r => r.fileName)
            .map(r => ({
            documentType: r.isCustom ? 'optional_file' : r.documentName,
            documentName: r.documentName,
            fileName: r.fileName,
            gcsPath: r.gcsPath,
        })),
    };
}
function setupButtons() {
    const btnBack = document.getElementById('btnBack');
    if (btnBack) {
        btnBack.addEventListener('click', (e) => {
            e.preventDefault();
            showPopupConfirm({
                text: '一覧画面に戻りますか。入力内容はクリアされます。',
                showBackdrop: true,
                onConfirm: () => navigate('/field-survey-request-list')
            });
        });
    }
    const btnRetry = document.getElementById('btnRetry');
    if (btnRetry) {
        // TODO: 再依頼の採番・BOXフォルダ方針確定までの暫定措置（確定後に有効化する）
        btnRetry.disabled = true;
        btnRetry.style.opacity = '0.5';
        btnRetry.style.cursor = 'not-allowed';
        btnRetry.addEventListener('click', () => {
            if (!validateForm())
                return;
            showPopupConfirm({
                text: '依頼を行いますか。',
                showBackdrop: true,
                onConfirm: async () => {
                    try {
                        startLoadingDisplay();
                        const result = await retryFieldSurveyRequest(collectFormData());
                        endLoadingDisplay();
                        const message = result.boxUploadFailed
                            ? '現地調査依頼が完了しました。\n※BOXへの書類格納に失敗しました。管理者にお問い合わせください。'
                            : '現地調査依頼が完了しました。';
                        showPopupAlert({ text: message, showBackdrop: true, onClose: () => navigate('/field-survey-request-list') });
                    }
                    catch (error) {
                        endLoadingDisplay();
                        console.error('再依頼に失敗:', error);
                        showPopupAlert({ text: getApiErrorMessage(error, '再依頼に失敗しました。しばらく時間をおいて再度お試しください。'), showBackdrop: true });
                    }
                }
            });
        });
    }
    const btnAddDocument = document.getElementById('btnAddDocument');
    if (btnAddDocument) {
        btnAddDocument.addEventListener('click', () => {
            documentRows.push({ documentName: '', fileName: '', uploader: '', uploadDate: '', isCustom: true, gcsPath: '' });
            renderDocumentTable();
        });
    }
    const btnCandidateSearch = document.getElementById('btnCandidateSearch');
    if (btnCandidateSearch) {
        btnCandidateSearch.addEventListener('click', () => openCandidateSearch());
    }
    const btnStoreSearch = document.getElementById('btnStoreSearch');
    if (btnStoreSearch) {
        btnStoreSearch.addEventListener('click', () => openStoreSearch());
    }
    const btnRequesterSearch = document.getElementById('btnRequesterSearch');
    if (btnRequesterSearch) {
        btnRequesterSearch.addEventListener('click', () => openEmployeeSearch('txtRequester', 'txtRequesterCode', 'REQUESTER'));
    }
    const btnApproverSearch = document.getElementById('btnApproverSearch');
    if (btnApproverSearch) {
        btnApproverSearch.addEventListener('click', () => openEmployeeSearch('txtApprover', 'txtApproverCode', 'APPROVER'));
    }
    const btnDmSearch = document.getElementById('btnDmSearch');
    if (btnDmSearch) {
        btnDmSearch.addEventListener('click', () => openEmployeeSearch('txtDm', 'txtDmCode', 'DM'));
    }
    const btnDesignOfficeSearch = document.getElementById('btnDesignOfficeSearch');
    if (btnDesignOfficeSearch) {
        btnDesignOfficeSearch.addEventListener('click', () => openVendorSearch('txtDesignOffice', 'txtDesignOfficeCode'));
    }
}
export const initializeFieldSurveyRequestRetry = async (requestId) => {
    try {
        startLoadingDisplay();
        const content = await getHtml('/parts/fieldSurveyRequestRetry.html');
        const subContents = document.getElementById('subContents');
        if (content && subContents) {
            subContents.innerHTML = content;
        }
        await initializeHeader('現地調査依頼');
        if (!isOperationPermissionsLoaded()) {
            const ops = await fetchOperationPermissions();
            setOperationPermissions(ops);
        }
        const op = getOperationPermission('SITE_SURVEY');
        if (op && !op.ssReRequest) {
            endLoadingDisplay();
            await showPopupAlert({ text: '再依頼の権限がありません。', showBackdrop: true });
            navigate('/fieldSurveyRequest');
            return;
        }
        if (!isCodeMasterLoaded()) {
            const codeMaster = await fetchCodeMaster();
            setCodeMaster(codeMaster);
        }
        await Promise.all([loadMockZoData(), loadMockDoData()]);
        initializeFormSelects();
        if (requestId) {
            const detail = await fetchFieldSurveyRequestDetail(requestId);
            populateForm(detail);
        }
        await initializeRequester();
        setupHandlingTypeControl();
        const selHandlingType = document.getElementById('selHandlingType');
        if (selHandlingType) {
            selHandlingType.disabled = true;
            selHandlingType.classList.add('form-input-disabled');
        }
        const txtCandidateId = document.getElementById('txtCandidateId');
        if (txtCandidateId) {
            txtCandidateId.disabled = true;
            txtCandidateId.classList.add('form-input-disabled');
        }
        const btnCandidateSearchEl = document.getElementById('btnCandidateSearch');
        if (btnCandidateSearchEl) {
            btnCandidateSearchEl.disabled = true;
            btnCandidateSearchEl.style.opacity = '0.5';
        }
        initializeDocumentTable();
        setupButtons();
        endLoadingDisplay();
    }
    catch (error) {
        console.error('再依頼画面の初期化に失敗しました:', error);
        endLoadingDisplay();
        throw error;
    }
};
